import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import MenuModel from '../model/menu/menuModel';
import { MainService } from '../api/main.service';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  //#region Constructor

  constructor(
    private service: MainService
  ) {}

  //#endregion

  //#region Propiedades

  public MenuSubject = new BehaviorSubject<MenuModel[]>([])
  public ShowMenuSubject = new BehaviorSubject<boolean>(true)

  //#endregion

  //#region Menú

  private async LoadMenu(): Promise<MenuModel[]> {

    let menu: MenuModel[] = [],
      menuOption: MenuModel

    // Inicio
    menuOption = new MenuModel()
    menuOption.title = "Inicio"
    menuOption.icon = 'home-outline'
    menuOption.url = '/home'
    menu.push(menuOption)
    
    // Trabajos a realizar
    menuOption = new MenuModel()
    menuOption.title = "Trabajos a realizar"
    menuOption.icon = 'layers-outline'
    menuOption.url = '/inspecciones-list'
    menu.push(menuOption)

    // Depuración de OTs
    if (await this.service.IsDebugUser()) {
      menuOption = new MenuModel()
      menuOption.title = "Depuración de OTs"
      menuOption.icon = "layers-outline"
      menuOption.url = '/inspecciones-debug-list'
      menu.push(menuOption)
    }

    // Trabajos en proceso
    menuOption = new MenuModel()
    menuOption.title = 'Trabajos en proceso'
    menuOption.icon = 'reader-outline'
    menuOption.url = '/ordenes-trabajo'
    menu.push(menuOption)

    // Perfil de usuario
    menuOption = new MenuModel()
    menuOption.title = 'Perfil de usuario'
    menuOption.icon = 'person-outline'
    menuOption.url = '/perfil-usuario'
    menu.push(menuOption)

    // Gestión de datos
    menuOption = new MenuModel()
    menuOption.title = "Gestión de datos"
    menuOption.icon = 'server-outline'
    menuOption.url = '/gestion-datos/solicitud-acceso'
    menu.push(menuOption)

    return menu

  }

  //#endregion

  //#region Util

  public async RecargarMenu(): Promise<void> {
    let menu = await this.LoadMenu()
    this.MenuSubject.next(menu)
  }

  //#endregion
  
}
